( function( $ ) {
	const initBlock = function( $section ) {
		function getCloneCount( $container ) {
			const $slide = $container.find( '.section-social-feed__slide-wrap' );
			const slideWidth = $slide.outerWidth();
			const sliderWidth = $container.outerWidth();
			const numberOfSlides = $slide.length;

			const requiredNumberOfSlides = Math.ceil( sliderWidth / slideWidth ) * 2;
			const result = Math.ceil( requiredNumberOfSlides / numberOfSlides ) - 1;

			return result < 1 ? 1 : result;
		}

		function getLoopState( $container ) {
			const numberOfSlider = $container.find( '.swiper-slide' ).length;

			return numberOfSlider > 3;
		}

		function initInfinitySlider( section ) {
			const $infiniteslider = $( section ).find( '.js-social-feed-infiniteslide' );

			$section.find( '.infiniteslide_wrap' ).replaceWith( function() {
				return $( $infiniteslider, this );
			} );

			$infiniteslider.find( '.infiniteslide_clone' ).remove();
			$infiniteslider.find( '.slide' ).removeAttr( 'style' );			
			
			
			$infiniteslider.each( function() {
				const $container = $( this );

				const loadInfiniteslide = () => {
					$container.infiniteslide( {
						'speed': 50, //speed this is px/min
						'direction': 'left', //choose  up/down/left/right
						'pauseonhover': true, //if true,stop onmouseover
						'responsive': false, //width/height recalculation on window resize. child element's width/height define %/vw/vh,this set true.
						'clone': getCloneCount( $container ) //if child elements are too few (elements can't "infinite"), set 2 or over.
					} );
				};
				window.app.loadVendor( 'Infiniteslide', loadInfiniteslide );
			} );
		}

		function initSwiperSlider( section ) {
			const $slider = $( section ).find( '.js-social-feed-slider' );

			$slider.each( function() {
				const $container = $( this );

				if ( $container[0].swiper ) {
					this.swiper.destroy( true, true );
				}

				const loadSwiper = () => {
					new Swiper( $container[0], {
						loop: getLoopState( $container ),
						slidesPerView: 'auto',
						loopPreventsSlide: false,
						a11y: {
							enabled: false
						},
						navigation: {
							nextEl: $container.closest( '.section-social-feed__slider-wrap' ).find( '.swiper-button-next' )[0],
							prevEl: $container.closest( '.section-social-feed__slider-wrap' ).find( '.swiper-button-prev' )[0],
						},
						breakpoints: {
							0: {
								spaceBetween: 16,
							},
							768: {
								spaceBetween: 27,
							},
							1280: {
								spaceBetween: 40,
							}
						}
					} );
				};

				window.app.loadVendor( 'Swiper', loadSwiper );
			} );
		}

		initInfinitySlider( $section );
		initSwiperSlider( $section );
	};

	window.app.loadBlock( initBlock, 'section-social-feed', '.section-social-feed' );
} )( jQuery );